import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UserActions from '@Actions/userActions';
import Success from '@Images/admin/success.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';

/**
 *
 */
function WhatsappSuccess({ history, getUserProfile }) {
  return (
    <div className="whatsapp-success__wrapper">

      <div className="whatsapp-success-action-wrapper__align">

        <img
          src={Success}
          alt="success "
          width="70px"
          height="70px"
          style={{
            marginBottom: '12px',
            marginTop: '10px',
          }}
        />

        <p className="whatsapp-success-heading">Your Whatsapp account is now Connected!</p>

        <div style={{ marginTop: '40px' }}>

          <H3Button
            text="Back to Integrations"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => {
              getUserProfile(() => {
                history.push('/admin/integration/');
              });
            }}
            customClass="whatsapp__back-submit"
          />
        </div>

      </div>
    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = (dispatch) => ({
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),

});
WhatsappSuccess.propTypes = {
  history: PropTypes.any,
  getUserProfile: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WhatsappSuccess));
